import React from "react";
import { Grid, Typography, Button, Box, Link, useTheme } from "@mui/material";
import PlayStoreIcon from "../../assets/images/google-play.png";
import AppStoreIcon from "../../assets/images/app-store.png";
import SmartPhone from "../../assets/images/smartphone.png";
import Iphone from "../../assets/images/iphone.png";

export const LandingPage = () => {
  const appStoreLink = "APP_STORE_LINK"; // Replace with the actual App Store link
  const playStoreLink = "PLAY_STORE_LINK"; // Replace with the actual Play Store link
  const theme = useTheme();

  return (
    <Box
      sx={{
        // flexGrow: 1,
        px: {
          xs: theme.spacing(5),
          md: theme.spacing(10),
          lg: theme.spacing(15),
        },
        py: theme.spacing(10),
      }}
    >
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        <Grid item xs={12} md={6} textAlign={{ xs: "center", md: "left" }}>
          <Typography variant="h2" fontWeight={"bold"} gutterBottom>
            Welcome to Rotten Egg!
          </Typography>
          <Typography
            variant="body1"
            sx={{ mb: theme.spacing(5), fontSize: "1.2rem" }}
          >
            Get ready to embark on an exciting adventure with Rotten Egg.
            Available now on your favorite devices.
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              justifyContent: {xs: "center", md: "flex-start"},
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <Link href={appStoreLink} target="_blank" rel="noopener noreferrer">
              <Button
                variant="contained"
                sx={{ mr: 1, backgroundColor: "black", textTransform: "none" }}
                startIcon={
                  <img
                    src={AppStoreIcon}
                    alt="App Store"
                    style={{ height: 36 }}
                  />
                }
              >
                Get it on App Store
              </Button>
            </Link>
            <Link
              href={playStoreLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                variant="contained"
                sx={{ textTransform: "none" }}
                startIcon={
                  <img
                    src={PlayStoreIcon}
                    alt="Play Store"
                    style={{ height: 36 }}
                  />
                }
              >
                Get it on Play Store
              </Button>
            </Link>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          {/* Replace URLs with the actual image links */}
          <img
            src={Iphone}
            alt="iOS Phone"
            style={{ height: "350px", marginRight: "20px" }}
          />
          <img
            src={SmartPhone}
            alt="Android Phone"
            style={{ height: "350px" }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
